// Bootstrap
import '@popperjs/core';
import * as bootstrap from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
global.bootstrap = bootstrap;

// jQuery
import $ from  "jquery";
global.$ = $
global.jQuery = $;
window.jQuery = $;

// Another tab may have started payment while this page was still open.
$(document).ajaxError((_event, xhr) => {
    if (xhr.status === 409 && xhr.responseJSON?.checkoutReserved && xhr.responseJSON.redirectUrl) {
        window.location.assign(xhr.responseJSON.redirectUrl);
    } else if (xhr.status === 409 && xhr.responseJSON?.reloadRequired && xhr.responseJSON.message) {
        // Preserve unsaved input; let the customer review the cart instead of replaying the POST.
        toastr.warning(xhr.responseJSON.message);
    }
});

// jQuery validation (for .NET validation)
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

// Fonts
import '../fonts/Poppins/poppins.css';

// Custom CSS imports
import '../css/site.css';
import '../css/photo-change-modal.css';
import '../css/print-crop-preview.css';
import { createShopPhotoPreview, updatePrintCropInfo, initializePrintCropPhotos } from './printCropPreview';
global.createShopPhotoPreview = createShopPhotoPreview;
global.updatePrintCropInfo = updatePrintCropInfo;
global.initializePrintCropPhotos = initializePrintCropPhotos;
import { initializeCartPrintCropping } from './printCropEditor';
global.initializeCartPrintCropping = initializeCartPrintCropping;
import { initializeCartProductEditor } from './cartProductEditor';
global.initializeCartProductEditor = initializeCartProductEditor;
import './photoSwipePreview';

// function and enums to create a photo grid
import { GridType, Effect, Orientation, Mockup, PhotoProductViewModel, createPhotoProduct, drawSpecialGrid9X13Plus4TimesMini, drawSpecialGrid9X13Plus2Times6X9 } from "./photoProduct";
global.PhotoEffect = Effect;
global.PhotoGridType = GridType;
global.PhotoOrientation = Orientation;
global.PhotoMockup = Mockup;
global.PhotoProductViewModel = PhotoProductViewModel;
global.createPhotoProduct = createPhotoProduct;
global.drawSpecialGrid9X13Plus4TimesMini = drawSpecialGrid9X13Plus4TimesMini;
global.drawSpecialGrid9X13Plus2Times6X9 = drawSpecialGrid9X13Plus2Times6X9;

// toastr for notifications
import toastr from 'toastr'
import 'toastr/build/toastr.css'
global.toastr = toastr;

// DOMPurify for sanitizing AJAX-loaded HTML (e.g. cart photo selection modal)
import DOMPurify from 'dompurify';
global.DOMPurify = DOMPurify;

console.log('The \'index\' bundle has been loaded!');

import { initializeStudentCardCropping } from './studentCardCropping';
document.addEventListener('DOMContentLoaded', () => initializeStudentCardCropping());
